import React from 'react';
import AddIcon from '@mui/icons-material/Add';
import { Typography } from '@mui/material';
import {
  FieldPathByValue,
  useFieldArray,
  useFormContext,
} from 'react-hook-form';
import {
  AddButton,
  ButtonsContainer,
  ConditionalDivider,
  InnerContainer,
  Wrapper,
} from 'src/components/Forms/CustomFormulaForm/Filters/FilterCollapse/styled';
import { MetricFilterItem } from 'src/utils/gql/types';

import { DashboardForm, FilterCollapseProps } from '../../types';

import { Rule } from './Rule';
import { RulesGroup } from './RulesGroup';

export const FilterCollapse = ({
  filter,
  formulaItemIndex,
}: FilterCollapseProps) => {
  const { control } = useFormContext<DashboardForm>();

  const filtersPath: `filters.${number}.values` = `filters.${formulaItemIndex}.values`;

  const { fields, append, remove } = useFieldArray({
    control,
    name: filtersPath,
  });

  const firstOperatorKey = filter.operators[0].key;

  const handleAddGroup = () =>
    append({ filtersGroup: [{ operator: firstOperatorKey, values: [] }] });
  const handleAddRule = () =>
    append({ operator: firstOperatorKey, values: [] });

  return (
    <Wrapper>
      {fields.map((field, index) => (
        <InnerContainer key={field.id}>
          {'filtersGroup' in field ? (
            <RulesGroup
              groupName={`Group of rules ${index + 1}`}
              filterItemIndex={index}
              formulaItemIndex={formulaItemIndex}
              onDeleteGroup={() => remove(index)}
              filter={filter}
            />
          ) : (
            <Rule
              selectedDimensionFilter={filter}
              ruleName={`Rule ${index + 1}`}
              filterPath={
                `${filtersPath}.${index}` as FieldPathByValue<
                  DashboardForm,
                  MetricFilterItem
                >
              }
              onDelete={() => remove(index)}
            />
          )}
          {fields.length !== index + 1 && (
            <ConditionalDivider>OR</ConditionalDivider>
          )}
        </InnerContainer>
      ))}
      <ButtonsContainer>
        <AddButton onClick={handleAddRule}>
          <AddIcon />
          <Typography>Add rule</Typography>
        </AddButton>
        <AddButton onClick={handleAddGroup}>
          <AddIcon />
          <Typography>Add group</Typography>
        </AddButton>
      </ButtonsContainer>
    </Wrapper>
  );
};
